import { Injectable, OnInit } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Config } from '../../config/config';

@Injectable()
export class LoginBBMMService {
    constructor(private http: Http) { }
    login(username, password) {
        var headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        var form_data = "username=" + encodeURIComponent(username) + "&password=" + encodeURIComponent(password) + "&grant_type=password";
        return this.http.post(Config.loginUrl, form_data, { headers: headers })
            .map(reponse => reponse.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/login-bbmm/loginbbmm.service.ts